import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouteNavigationService } from '../route-navigation.service';
import { Store } from '@ngxs/store';
import { ApplicationStateModel, selectAppStateSnapshot, StoreState } from '../../../app.state';
import { AuthenticationService } from '../../services/authentication.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class LoggedInRouteGuard {
  constructor(private _store: Store,
              private _authenticationService: AuthenticationService,
              private _routeNavigationService: RouteNavigationService) {

  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._authenticationService.isInitialized$
      .pipe(
        filter(_ => !!_),
        map(_ => {
          const applicationState = selectAppStateSnapshot(this._store);

          if (!applicationState?.user) {
            this._routeNavigationService.saveRouteToNavigateAfterLogin(state.url);

            this._routeNavigationService.goToLoginAsync(false);
          }

          return !!applicationState.user;
        }),
      );
  }
}
